import {
  FormControl,
  FormControlLabel,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
} from '@mui/material'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useSelector } from 'react-redux'

import type { RootState } from '../store'
import LabelWithTooltip from './LabelWithTooltip'

type Option = {
  value: string
  label: string
}

type FormState = {
  form: { [key: string]: any }
}

type RadioProps = {
  name: string
  control: Control<any>
  label?: string
  options: Option[]
  row?: boolean
  tooltip?: string
  onFormValueChange?: (name: string, value: string) => void
  formStateKey?: keyof RootState
  titleSx?: any
}

const Radio: React.FC<RadioProps> = ({
  name,
  control,
  label,
  options,
  row = true,
  tooltip = '',
  titleSx,
  onFormValueChange,
  formStateKey = 'shadeGuide',
}) => {
  const selectedValue =
    useSelector(
      (state: RootState) => (state[formStateKey] as FormState)?.form?.[name],
    ) ||
    options[0]?.value ||
    ''

  return (
    <FormControl>
      {label && (
        <LabelWithTooltip
          titleSx={titleSx}
          label={label}
          tooltipText={tooltip}
        />
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <MuiRadioGroup
            {...field}
            row={row}
            value={selectedValue}
            onChange={(event) => {
              field.onChange(event)
              onFormValueChange?.(name, event.target.value)
            }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<MuiRadio />}
                label={option.label}
              />
            ))}
          </MuiRadioGroup>
        )}
      />
    </FormControl>
  )
}

export default Radio
